const deviceStatus = [
    {
        label: "全部",
        value: ""
    },
    {
        label: "设备通电开阀",
        value: 1
    },
    {
        label: "设备断电关阀",
        value: 2
    },
    {
        label: "设备离线",
        value: 3
    }
]
const deviceSort = [
    {
        label: "默认排序",
        value: '',
    },
    {
        label: "由大到小",
        value: 1,
    },
    {
        label: "由小到大",
        value: 2,
    },
]

const deviceLabel = [
    {
        label: "设备名称",
        prop: "deviceName",
        width: "160"
    },
    {
        label: "表号",
        prop: "tagNo",
        width: "170"
    },
    {
        label: "租客姓名",
        prop: "nickName",
        width: "160"
    },
    {
        label: "电话",
        prop: "phone",
        width: "145"
    },
    {
        label: "剩余水电量",
        prop: "remainKwh",
        width: "200"
    },
    {
        label: "状态",
        prop: "status",
        width: "170"
    },
    {
        label: "刷新时间",
        prop: "dataTime",
        width: "160"
    }
]

const priceLabel = [
    {
        label: "名称",
        prop: "deviceName",
        width: ""
    },
    {
        label: "当前价格",
        prop: "price",
        width: ""
    }
]

const recordLabel = [
    {
        label: "项目",
        prop: "project",
        width: "90"
    },
    {
        label: "操作人",
        prop: "people",
        width: "85"
    },
    {
        label: "支付时间",
        prop: "createTime",
        width: "100"
    },
    {
        label: "充值金额3",
        prop: "amount",
        width: "100"
    },
    {
        label: "充值电量3",
        prop: "kwh",
        width: "130"
    }
]
const waterRecordLabel = [
    {
        label: "项目",
        prop: "project",
        width: "90"
    },
    {
        label: "操作人",
        prop: "people",
        width: "85"
    },
    {
        label: "支付时间",
        prop: "createTime",
        width: "100"
    },
    {
        label: "充值金额3",
        prop: "amount",
        width: "100"
    },
    {
        label: "充值水量1",
        prop: "water",
        width: "120"
    }
]
import ChangeTenant from '@/assets/img/device_list/ChangeTenant.png'
import AgentRecharge from '@/assets/img/device_list/AgentRecharge.png'
import PowerOn from '@/assets/img/device_list/PowerOn.png'
import PowerOff from '@/assets/img/device_list/PowerOff.png'
import Refresh from '@/assets/img/device_list/Refresh.png'
import ClearTampering from '@/assets/img/device_list/ClearTampering.png'
import Reset from '@/assets/img/device_list/Reset.png'
import ModifyPrice from '@/assets/img/device_list/ModifyPrice.png'
import ThresholdSetting from '@/assets/img/device_list/Threshold.png'
import ValueOpen from '@/assets/img/device_list/ValueOpen.png'
import ValueClose from '@/assets/img/device_list/ValueClose.png'

const deviceOperImg = [
    {
        img: ChangeTenant,
        title: "更换租客",
        type: 1,
    },
    {
        img: AgentRecharge,
        title: "代客充值",
        type: 2,
    },
    {
        img: PowerOn,
        title: "通电",
        type: 3,
    },
    {
        img: PowerOff,
        title: "断电",
        type: 4,
    },
    {
        img: Refresh,
        title: "刷新",
        type: 5,
    },
    {
        img: ClearTampering,
        title: "清窃电",
        type: 6,
    },
    {
        img: Reset,
        title: "清零",
        type: 7,
    },
    {
        img: ModifyPrice,
        title: "修改价格",
        type: 8,
    },
    {
        img: ThresholdSetting,
        title: "阈值设置",
        type: 9
    }
]
const deviceWaterOperImg = [
    {
        img: ChangeTenant,
        title: "更换租客",
        type: 1,
    },
    {
        img: AgentRecharge,
        title: "代客充值",
        type: 2,
    },
    {
        img: ValueOpen,
        title: "开阀",
        type: 3,
    },
    {
        img: ValueClose,
        title: "关阀",
        type: 4,
    },
    {
        img: Reset,
        title: "水表清零",
        type: 5,
    },
    {
        img: ModifyPrice,
        title: "修改价格",
        type: 6,
    },
]


export { deviceStatus, deviceSort, deviceLabel, priceLabel, recordLabel, waterRecordLabel, deviceOperImg, deviceWaterOperImg }
